import React from "react"

import {FieldDef} from "./FieldDef.js"
import {WidgetModel} from "./WidgetModel.js"
import {MC} from "../client/MC.js"

class InteractiveField extends React.Component {

  state = {x: this.props.field.initPosition.x,
    y: this.props.field.initPosition.y,
    left: this.props.style.left,
    top: this.props.style.top,
    width: this.props.style.width,
    height: this.props.style.height,
    initPosition: this.props.field.initPosition};
  refRoot = React.createRef()  
  
  componentDidMount() {
    this.point = this.state.initPosition
    this.props.modelerReact.interactiveFieldReact = this
    document.addEventListener("mousemove", this.handleMousemove)
    document.addEventListener("mouseup", this.handleMouseup)
    this.field = this.props.field.originalField;
    this.modelerReact = this.field.getModelerReact();
    this.formBeforeChange = this.modelerReact.state.form.getCopy();
    this.changed = false;
    this.deleted = false;
    if (this.field.isInPalette) {
        this.makeNewFieldFromPallete(this.field.id);
    }
    this.columnWidth = this.props.field.columnWidth;
    if (this.props.field.offsetChange ||  this.props.field.resizeChange) {
      this.beforeColumns = this.field.beforeColumns();
      this.initOffset = this.field.offset();
    }
    this.modelerReact.setState({placeholderField: this.field.rbsid});
    this.modelerReact.setSelectedField(this.field.rbsid);
    this.adjustTopLeft();
    this.adjustWidthAndHeight();
  }

  componentWillUnmount() {
    document.removeEventListener("mousemove", this.handleMousemove)
    document.removeEventListener("mouseup", this.handleMouseup)
  }

  handleMouseup = () => {
    let actualForm = this.modelerReact.state.form
    if (!formEqual(actualForm, this.formBeforeChange)) {
      this.modelerReact.store(this.formBeforeChange)
    }
    this.interactionEnd = true
    this.modelerReact.setState({placeholderField: null,
                                interactiveField: null})
    document.body.style.cursor = ""
  }

  handleMousemove = (event) => {
      this.point = {x: event.pageX, y: event.pageY}
      if (this.props.field.resizeChange) {
        this.checkGridColumnsChange()
      } else if (this.props.field.offsetChange) {
        this.setState(this.point)
        this.checkOffset()
      } else {
        this.setState(this.point)
        this.checkMove()
        let x = event.pageX
        let y = event.pageY
        let self = this
        setTimeout(function() {
          if (x == self.point.x && y == self.point.y) {
            if (!self.interactionEnd) {
              self.checkInAndOut()
            }
          }
        }, 200)
      }
  }

  makeNewFieldFromPallete = () => {
    var self = this;
    var flow = this.props.field.flow;
    var palette = WidgetModel.getFieldsPalette();
    var form = this.modelerReact.state.form;

    var fieldFromPalette = palette.find(field => field.id == self.field.id);
    this.field = MC.extend({}, fieldFromPalette)
    FieldDef.setProto(this.field);
    // panel not has value and title must be preserved for putting inside tabpanel
    if (MC.getFieldParamValue(this.field.param, '@titlePlacement') === 'INV') {
      if (this.field.widget !== 'panel') {
        this.field.setOption(["param", "value"], this.field.getOption(["param", "@title"]))
      }
      this.field.setOption(["param", "@title"], "")
    }
    if (this.field.widget === 'datebox') {
      let widgetDef = WidgetModel.findWidgetByName(this.field.widget)
      if (Array.isArray(widgetDef['def:dataType'])) {
        this.field.setOption(["basictype"], widgetDef['def:dataType'][0])
      }
    }
    WidgetModel.deleteUnsupportedParams(this.field);
    var count = 1;
    while (form.findFieldByName(this.field.id + count)) {
      count++;
    }
    this.field.setOption(["id"], this.field.id + count);
    this.field.flow = flow;
    this.deleted = true;
    this.field.grid = [];
    if (this.modelerReact.state.form.fields.length == 0) {
      this.field.ensureGrid("medium");
    }
    this.field.addGrid();
    this.field.isNotStored = true;
    this.field.generateRbsId();
    this.checkUndelete();
    if (!this.deleted) {
      this.checkIn();
    }
  };

  afterChange = () => {
    this.modelerReact.formWasChanged();
    if (!this.changed) {
      this.changed = true;
    }
    if (this.point && !this.props.field.offsetChange && !this.props.field.resizeChange) {
      this.adjustInteracted();
    }
  };

  onInOutChange = () => {
    delete this.offsets;
    delete this.rows;
  };

  adjustHeight = () => {
    let placeholder = document.querySelector(".placeholder")
    if (placeholder) {
      this.setState({height: placeholder.offsetHeight})
    }
  }

  adjustWidthAndHeight = () => {
    let placeholder = document.querySelector(".placeholder")
    if (placeholder) {
      this.setState({width: placeholder.offsetWidth, height: placeholder.offsetHeight})
    }
  }

  adjustTopLeft = () => {
    let placeholder = document.querySelector(".placeholder")
    if (placeholder) {
      let form = document.querySelector("#modeler .mnc.form")
      let left = MC.offset(placeholder).left - MC.offset(form).left
      let top = MC.offset(placeholder).top - MC.offset(form).top
      this.setState({left: left, top: top})
    }
  }

  adjustInteractedToBeUnderCursor = () => {
    let interactiveField = this.refRoot.current
    let left = MC.offset(interactiveField).left
    let top = MC.offset(interactiveField).top
    let height = interactiveField.offsetHeight
    let width = interactiveField.offsetWidth
    let x = this.state.initPosition.x
    let y = this.state.initPosition.y
    if (this.point.x > left + width) {
      x -= (this.point.x - (left + width)) + 10
    }
    if (this.point.y > top + height) {
      y -= (this.point.y - (top + height)) + 10
    }
    this.setState({initPosition: {x: x, y: y}})
  }

  adjustInteracted = () => {
    this.adjustWidthAndHeight();
    this.adjustInteractedToBeUnderCursor();
  }

  checkGridColumnsChange = () => {
    let node = this.refRoot.current
    this.setState({width: this.point.x - MC.offset(node).left})
    let currentColumns
    if (this.field.isInTabPanel()) {
      currentColumns = 12
    } else {
      let currentWidth = MC.outerWidthIncludeMargin(node)
      currentColumns = Math.max(1, Math.min(Math.ceil(currentWidth / this.columnWidth), 12))
    }
    if (this.field.columns() != currentColumns) {
      this.field.setColumns(currentColumns)
      this.afterChange()
    }
    this.adjustHeight()
    this.adjustTopLeft()
  }

  checkInAndOut = () => {
    if (this.deleted) {
        this.checkUndelete();
    }
    if (!this.deleted && !this.field.isTableFilterField()) {
      this.checkIn();
      this.checkOut();
    }
  };

  checkMove = () => {
    if (!this.deleted) {
      if (this.field.isTableFilterField()) {
        this.checkFilterFieldMove();
      } else if (this.field.isInTable()) {
        this.checkTableColumn();
      } else if (this.field.isInTabPanel()) {
        this.checkTabPosition();
      } else  {
        this.checkGrid();
      }
    }
  };

  checkFilterFieldMove = () => {
    const table = this.field.getTrueParent()
    if (!table || !table.isTable()) return
    const filterColIndex = this.getFilterRowTargetColumn(table)
    if (filterColIndex === -1) {
      // Cursor left the filter row — check if it moved into the table body
      const tableNode = table.getNode()
      if (!tableNode) return
      if (!isPointInBox(table.getBBox(), this.point)) {
        // Cursor left the table entirely — transition to a normal field in the table's parent
        const tableParent = table.getTrueParent()
        if (!tableParent) return
        this.field.removeFromContainer()
        this.placeToContainer(tableParent)
        this.afterChange()
        this.onInOutChange()
        return
      }
      const filterRow = tableNode.querySelector('.filter-row')
      if (filterRow) {
        const off = MC.offset(filterRow)
        if (isPointInBox({left: off.left, top: off.top, width: filterRow.offsetWidth, height: filterRow.offsetHeight}, this.point)) return
      }
      const tableFields = table.getSubfields()
      if (tableFields.length === 0) return
      const columnsOffsets = FieldDef.computeColumnsOffsets(tableFields)
      if (findNearPoint(columnsOffsets, this.point.x) !== -1) return // near boundary, anti-blink
      const idx = findOffsetIndex(columnsOffsets, this.point.x)
      if (idx < 0 || idx >= tableFields.length) return
      this.field.removeFromContainer()
      table.putToTable(this.field, idx)
      this.afterChange()
      this.onInOutChange()
      return
    }
    const tableFields = table.getSubfields()
    const column = tableFields[filterColIndex]
    if (!column) return
    const columnParam = table.param?.value?.['columns']?.value?.[column.id]
    const colFilterFields = columnParam ? MC.findFieldsInParams(columnParam, false, ['filterField']) : []
    if (colFilterFields.some(f => f === this.field || f.rbsid === this.field.rbsid)) return
    if (colFilterFields.length > 0) return
    this.field.removeFromContainer()
    this.field.addToParam(table, column)
    this.field.addToParamDefinition(table, column)
    this.field.parent = table
    this.afterChange()
    this.onInOutChange()
  };

  checkOffset = () => {
    var initPosition = this.props.field.initPosition;
    var x = this.point.x - initPosition.x;
    var currentOffset =  this.initOffset + Math.round(x / this.columnWidth);
    var columns = this.field.columns();
    currentOffset = Math.min(Math.max(0,currentOffset), 12 - columns - this.beforeColumns);
    var offset = this.field.offset();
    var offsetChanged = offset !=  currentOffset;
    if (offsetChanged) {
      this.field.setOffset(currentOffset);
      this.afterChange();
    }
  };

  getTargetField = (field) => {
    var fields = field.getSubfields();
    var bboxes = fields.map(field => field.getBBox());
    var inIndex = bboxes.findIndex(bbox => isPointInBox(bbox, this.point));
    if (inIndex != -1) {
      return fields[inIndex];
    }
    const fieldInParams = field.param ? MC.findFieldsInParams(field.param, field.isTable()) : []
    for (let f of fieldInParams) {
      const bbox = f.getBBox()
      if (isPointInBox(bbox, this.point)) {
        return f
      }
    }
    return null
  }

  checkInHelp = (field) => {
    var targetField = this.getTargetField(field);
    if (targetField  && targetField != this.field) {
      if (WidgetModel.isSupportedChild(this.field.widget, targetField.widget)) {
        var placedIn = this.checkInHelp(targetField);
        if (!placedIn) {
          this.field.removeFromContainer();
          this.placeToContainer(targetField);
          this.afterChange();
          this.onInOutChange();
          return true;
        }
      } else {
        return this.checkInHelp(targetField);
      }
    } else {
      return false;
    }
  };

  placeToContainer = (container) => {
    if (container.isTable()) {
      const filterColIndex = this.getFilterRowTargetColumn(container)
      if (filterColIndex !== -1) {
        this.placeToFilterRow(container, filterColIndex)
      } else {
        this.placeToTable(container);
      }
    } else if (container.isWithoutGrid()) {
      var subfields = container.getSubfields();
      container.setSubfields(subfields.concat([this.field]));
      if (container.isTabPanel()) {
        this.field.setColumns(12);
      }
    } else {
      this.placeToGrid(container);
    }
  };

  checkIn = () => {
    var parent = this.field.getTrueParent();
    // If inside a filter panel, start from table level so we can find other filter panels
    if (parent.isTableFilterField()) {
      const table = parent.getTrueParent()
      if (table) {
        this.checkInHelp(table)
        return
      }
    }
    this.checkInHelp(parent)
  }

  checkOutHelp = (predecessor) => {
    if (!predecessor.isTopLevel()) {
      var bbox = predecessor.getBBox();
      if(!isPointInBox(bbox, this.point)) {
        var parent = predecessor.getTrueParent();
        if (WidgetModel.isSupportedChild(this.field.widget, parent.widget)) {
          this.field.removeFromContainer();
          this.placeToContainer(parent);
          this.afterChange();
          this.onInOutChange();
        }
        this.checkOutHelp(parent);
      }
    }
  };

  checkOut = () => {
    this.checkOutHelp(this.field.getTrueParent());
  };

  innerModelerBBox = () => {
    let el = document.querySelector("#modeler > .modelerContainer")
    return {left: MC.offset(el).left, top: MC.offset(el).top, width: el.offsetWidth, height: el.offsetHeight}
  }

  checkUndelete = () => {
    var bbox = this.innerModelerBBox();
    if(isPointInBox(bbox, this.point)) {
      var form = this.modelerReact.state.form;
      this.field.parent = form;
      this.placeToContainer(form)
      this.checkIn();
      this.deleted = false;
      this.afterChange();
    }
  };

  getColumnIndex = (fields) => {
    var columnsOffsets = FieldDef.computeColumnsOffsets(fields);
    return findNearPoint(columnsOffsets, this.point.x);
  };

  ensureTabPanelOffsets = (tabPanel) => {
    if (typeof this.offsets == "undefined") {
      this.offsets = tabPanel.getTabPanelMenuItemOffsets();
    }
  };

  checkTabPosition = () => {
    var tabPanel = this.field.getTrueParent();
    var subfields = tabPanel.getSubfields();
    var sourceIndex = subfields.findIndex(w => w == this.field);
    this.ensureTabPanelOffsets(tabPanel);
    FieldDef.correctIndexes(subfields);
    var targetIndex = findNearPoint(this.offsets, this.point.x);
    if (targetIndex != -1 && targetIndex != sourceIndex + 1 && targetIndex != sourceIndex) {
      moveElement(subfields, sourceIndex, targetIndex);
      tabPanel.setSubfields(subfields);
      this.afterChange();
    }
  };

  checkTableColumn = () => {
    var table = this.field.getTrueParent();
    // Check if cursor moved into the filter row
    const filterColIndex = this.getFilterRowTargetColumn(table)
    if (filterColIndex !== -1) {
      const tableFields = table.getSubfields()
      const column = tableFields[filterColIndex]
      if (column && column !== this.field) {
        const columnParam = table.param?.value?.['columns']?.value?.[column.id]
        const colFilterFields = columnParam ? MC.findFieldsInParams(columnParam, false, ['filterField']) : []
        if (colFilterFields.length === 0) {
          this.field.removeFromTable()
          this.field.addToParam(table, column)
          this.field.addToParamDefinition(table, column)
          this.field.parent = table
          this.afterChange()
          this.onInOutChange()
        }
      }
      return
    }
    var tableFields = table.getSubfields();
    var sourceIndex = tableFields.findIndex(w => w == this.field);
    var targetIndex = this.getColumnIndex(tableFields);
    if (targetIndex != -1 && targetIndex != sourceIndex + 1 && targetIndex != sourceIndex) {
      table.tableMoveColumn(sourceIndex, targetIndex);
      this.afterChange();
    }
  };

  ensureCheckGridRows = (parent) => {
    if (typeof this.rows == "undefined") {
      this.rows = parent.getRows();
    }
  };

  checkGrid = () => {
    var parent = this.field.getTrueParent();
    if (!parent) return;
    var rows = parent.getRows();
    var sourceRowIndex = rows.findIndex(row => row.includes(this.field));
    var sourceRow = rows[sourceRowIndex];
    if (sourceRow) {
        this.gridChanged = false;
        this.checkColumn(sourceRow);
        this.checkRow(rows, sourceRowIndex);
        if (this.gridChanged) {
          var subfields = flatten(rows);
          parent.setSubfields(subfields);
          FieldDef.correctIndexes(subfields);
          delete this.rows;
          this.afterChange();
        }
      }
  };

  checkColumn = (sourceRow) => {
      var sourceIndex = sourceRow.findIndex(w => w == this.field);
      var targetIndex = this.getColumnIndex(sourceRow);
      if (targetIndex != -1 && targetIndex != sourceIndex) {
        moveElement(sourceRow, sourceIndex, targetIndex);
        this.gridChanged = true;
      }
  };

  prepareRowsForCheckRow = (rows, sourceIndex) => {
    var offsets = FieldDef.computeRowsOffsets(rows);
    var targetIndex = findNearPoint(offsets, this.point.y, 20);
    if (targetIndex != -1) {
      if (sourceIndex >= targetIndex) {
        sourceIndex ++;
      }
      rows.splice(targetIndex , 0, []);
    }

    if (targetIndex == -1) {
      var targetIndex = findOffsetIndex(offsets, this.point.y);
      if (targetIndex == -1) {
        rows.unshift([]);
        targetIndex = 0;
        sourceIndex += 1;
      }
      if (targetIndex == rows.length) {
        rows.push([]);
      }
    }
    return [sourceIndex, targetIndex];
  };

  removeFieldFromRows = (rows, sourceIndex) => {
    var sourceRow = rows[sourceIndex];
    var sourceColumnIndex = sourceRow.findIndex(w => w == this.field);
    sourceRow.splice(sourceColumnIndex, 1);  // remove widget from its row
  };

  checkRow = (rows, sourceIndex) => {
      // check if the row of the widget has to be changed and change it

    var pair = this.prepareRowsForCheckRow(rows, sourceIndex);
    var sourceIndex = pair[0];
    var targetIndex = pair[1];
    if (targetIndex != sourceIndex) {
      this.removeFieldFromRows(rows, sourceIndex);
      var targetRow = rows[targetIndex];
      this.placeToRow(targetRow);

      this.gridChanged = true;
    }
  };

  prepareRowsForPlaceToGrid = (rows) => {
    var offsets = FieldDef.computeRowsOffsets(rows);
    var index = findNearPoint(offsets, this.point.y, 20);

    if (index == -1) {
        index = findOffsetIndex(offsets, this.point.y);
    } else {
      rows.splice(index , 0, []);
    }
    if (index == rows.length) { // add new row in the end
        rows.push([]);
    }
    if (index == -1 ) { // add new row at begining
        rows.unshift([]);
        index = 0;
    }
    return index;
  };

  placeToGrid = (targetField) => {
    var rows = targetField.getRows();
    var index = this.prepareRowsForPlaceToGrid(rows);
    var targetRow = rows[index];

    this.placeToRow(targetRow);
    targetField.setSubfields(flatten(rows));

  };

  getPlaceToRowIndex = (row) => {
    var columnsOffsets = FieldDef.computeColumnsOffsets(row);
    var index = findNearPoint(columnsOffsets,this.point.x);
    if (index == -1) {
        index = findOffsetIndex(columnsOffsets, this.point.x);
    }
    if (index == -1) {
        index = 0;
    }
    if (index != columnsOffsets.length) {
      index++;
    }
    return index;
  };

  getPlaceToTableIndex = (table) => {
    var tableFields = table.getSubfields();
    var columnsOffsets = FieldDef.computeColumnsOffsets(tableFields);
    var index = findNearPoint(columnsOffsets, this.point.x);
    if (index == -1) {
        index = findOffsetIndex(columnsOffsets, this.point.x);
    }
    if (index == -1) {
        index = 0;
    }
    return index;
  };

  placeToRow = (row) => {
    var index = this.getPlaceToRowIndex(row);
    row.splice(index, 0, this.field); // put widget to correct column
  };

  placeToTable = (table) => {
    var index = this.getPlaceToTableIndex(table);
    table.putToTable(this.field, index);
  };

  getFilterRowTargetColumn = (table) => {
    const tableNode = table.getNode()
    if (!tableNode) return -1
    const filterRow = tableNode.querySelector('.filter-row')
    if (!filterRow) return -1
    const off = MC.offset(filterRow)
    if (!isPointInBox({left: off.left, top: off.top, width: filterRow.offsetWidth, height: filterRow.offsetHeight}, this.point)) return -1
    const tableFields = table.getSubfields()
    if (tableFields.length === 0) return -1
    const columnsOffsets = FieldDef.computeColumnsOffsets(tableFields)
    // Use findNearPoint (snap zone) to avoid blinking at column boundaries,
    // same protection as checkTableColumn uses via getColumnIndex
    const nearIdx = findNearPoint(columnsOffsets, this.point.x)
    if (nearIdx !== -1) return -1  // cursor is near a boundary — don't commit yet
    const idx = findOffsetIndex(columnsOffsets, this.point.x)
    return idx >= 0 && idx < tableFields.length ? idx : -1
  };

  placeToFilterRow = (table, columnIndex) => {
    const column = table.getSubfields()[columnIndex]
    if (!column) return
    const columnParam = table.param?.value?.['columns']?.value?.[column.id]
    const colFilterFields = columnParam ? MC.findFieldsInParams(columnParam, false, ["filterField"]) : []
    if (colFilterFields.length > 0) return
    this.field.addToParam(table, column)
    this.field.addToParamDefinition(table, column)
    this.field.parent = table
  };

  render() {
    let transform = 'translate(' + (this.state.x - this.state.initPosition.x)+ 'px, ' + (this.state.y - this.state.initPosition.y) + 'px)'
    let style = {...this.props.style, transform: transform, width: this.state.width + "px", height: this.state.height + "px", left: this.state.left + "px",top: this.state.top + "px", margin: "0px"}
    return <div ref={this.refRoot} className={this.props.className} style={style}>{this.props.idLabel}{this.props.widget}</div>
  }
}


function flatten(arr) {
    return arr.reduce((acc, val) => acc.concat(
                Array.isArray(val) ? flatten(val) : val
                ),[]);
}

function findOffsetIndex (offsets, value) {
    return offsets.map(offset => value > offset).lastIndexOf(true);
}
function findNearPoint (points, value, distance) {
    if (!distance) {
        distance = 50;
    }
    return points.map(point => Math.abs(point - value) < distance).indexOf(true);
}

function moveElement (array, sourcePosition, targetPosition) {
    var element = array[sourcePosition];
    if (sourcePosition < targetPosition) {
        array.splice(targetPosition + 1, 0, element);
        array.splice(sourcePosition, 1);
    } else {
        array.splice(sourcePosition, 1);
        array.splice(targetPosition, 0, element);
    }
}

function isPointInBox (box, point) {
    var x = point.x;
    var y = point.y;
    var left = box.left;
    var top = box.top;
    var right = box.left + box.width;
    var bottom = box.top + box.height;

    return (left <= x) && (x <= right) && (top <= y) && (y <= bottom);
}

function formEqual ( x, y ) {
  if ( x == y ) return true;
    // if both x and y are null or undefined and exactly the same

  if ( ! ( x instanceof Object ) || ! ( y instanceof Object ) ) {
      //console.log("x != y", x, y);
      return false;}
    // if they are not strictly equal, they both need to be Objects

  //if ( x.constructor !== y.constructor ) return false;
    // they must have the exact same prototype chain, the closest we can do is
    // test there constructor.

  for ( var p in x ) {
    if (p == "parent") continue;
    if ( ! x.hasOwnProperty( p ) ) continue;
      // other properties were tested using x.constructor === y.constructor

    if ( ! y.hasOwnProperty( p ) ) {
        //console.log("y does not have property", x, y, p);
        return false;
    }
      // allows to compare x[ p ] and y[ p ] when set to undefined

    //if ( x[ p ] === y[ p ] ) continue;
      // if they have the same strict value or identity then they are equal

    //if ( typeof( x[ p ] ) !== "object" ) return false;
      // Numbers, Strings, Functions, Booleans must be strictly equal

    if ( ! formEqual( x[ p ],  y[ p ] ) ) {
        //console.log("x[p] != y[p]", x, y, p);
        return false;
    }
      // Objects and Arrays must be tested recursively
  }

  for ( p in y ) {
    if ( y.hasOwnProperty( p ) && ! x.hasOwnProperty( p ) ) {
         //console.log("x does not have property", x, y, p);
         return false;}
      // allows x[ p ] to be set to undefined
  }
  return true;
}

export {InteractiveField};